<template>
  <div
    v-if="list.length"
    class="youyan-video-progress"
    :class="{
      '!right-[135px] !z-[1000] !bottom-[10px]': isGlobalVersion() && !isChinese(),
    }"
  >
    <template v-if="showProgress?.[type]?.show">
      <div class="content">
        <div class="justify-between modal-title flex-y-center">
          <div class="font-medium">
            {{ title }}
            <span v-if="extra" class="ml-[5px] text-font-60 text-[12px]">{{ extra }}</span>
          </div>
          <div class="cursor-pointer text-font-40">
            <MinusOutlined class="mr-[20px] cursor-pointe" @click="toggleVisible" />
            <span class="ant-modal-close" @click="onClose">
              <iconpark-icon name="close"></iconpark-icon>
            </span>
          </div>
        </div>
        <div class="max-h-[170px] overflow-auto p-[16px] pb-[0]">
          <div
            v-for="item in list"
            :key="item.id"
            class="flex items-center justify-between my-[16px] progress-item"
          >
            <div class="flex items-center rounded-[8px] w-[60px] h-[60px] mr-[20px] bg-back-4">
              <Image
                class="w-full h-full rounded-[8px] object-contain"
                :src="item.cover ?? item.url ?? item.cover_url"
              />
            </div>
            <div class="flex-1 truncate">
              <div class="truncate text-14px -mb-[5px]">
                {{ item.title }}
              </div>
              <div class="mt-[10px] -mb-[8px] flex-y-center">
                <a-progress
                  :show-info="false"
                  class="progress-line"
                  :percent="item.percent"
                  size="small"
                />
              </div>
              <slot name="content" :dataSource="item"></slot>
            </div>
            <div
              class="text-right cursor-pointer min-w-[20px] pt-[11px] flex flex-nowrap gap-x-[5px]"
            >
              <slot name="action" :dataSource="item"></slot>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { MinusOutlined } from '@ant-design/icons-vue';
import Image from './image.vue';

const showProgress = useProgress();

const props = withDefaults(
  defineProps<{
    list: any[];
    type: ProgressName;
    title: string;
    extra?: string;
  }>(),
  {
    list: () => [],
    type: undefined,
    title: '',
  },
);

const emits = defineEmits(['close']);

const onClose = () => {
  setProgress(props.type, undefined);
  emits('close');
};

const toggleVisible = () => {
  setProgress(props.type, {
    show: false,
  });
};
</script>

<style lang="scss">
.youyan-video-progress {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 21;

  .modal-title {
    @apply px-[16px] py-[8px];
    border-bottom: 1px solid var(--back-3);
  }
  .progress-line {
    .ant-progress-bg {
      height: 2px !important;
    }
  }
  .content {
    @apply w-[500px] z-30 bg-back-1 rounded-[8px];
    border: 1px solid var(--back-3);
    box-shadow: 0px 2px 19px 0px rgba(0, 0, 0, 0.1);
  }
  .progress-item {
    &:first-child {
      margin-top: 0;
    }
    .text-color {
      color: rgba(255, 255, 255, 0.3);
    }
  }
}
</style>
